import Typhography from "../../shared/Typhography/Typhography";
import CustomPasswordInput from "../../shared/CustomPasswordInput/CustomPasswordInput";
import { useSimpleForm } from "../../hooks/useSimpleForm";
import { FC, Fragment, useMemo, useState } from "react";
import CustomButton from "../../shared/CustomButton/CustomButton";
import { useCustomNavigate } from "../../hooks/useCustomNavigate";
import CustomTextInput from "../../shared/CustomInput/CustomTextInput";

interface IRegistrationForm {
  onConfirm: (form: Record<string, any>) => void;
  statusCode: number;
}

export const RegistrationForm: FC<IRegistrationForm> = ({
  onConfirm,
  statusCode,
}) => {
  const { form, handleEventInputChange2 } = useSimpleForm({
    password: "",
    name: "",
    surname: "",
    confirmPassword: "",
    token: "",
  });

  const { navigate } = useCustomNavigate();

  const isConfirmButtonDisabled =
    !form.password || form.password !== form.confirmPassword;

  const handleConfirmCoach = () => {
    onConfirm(form);
  };

  const securityPassword = useMemo(() => {
    const conditions = [
      /\d/.test(form.password),
      // eslint-disable-next-line
      /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/.test(form.password),
      form.password.length >= 10,
    ];
    const trueConditions = conditions.filter(Boolean).length;
    return {
      percentual: Number((trueConditions / conditions.length) * 100).toFixed(0),
      number: trueConditions,
      label:
        trueConditions === 0 || trueConditions === 1
          ? "Bassa"
          : trueConditions === 2
          ? "Media"
          : "alta",
      colorLine:
        trueConditions === 0 || trueConditions === 1
          ? "error"
          : trueConditions === 2
          ? "warning"
          : "success",
    };
  }, [form.password]);

  return (
    <Fragment>
      <Typhography className="pb-3" size="bold-24">
        {statusCode === 0 ? "Registrati" : "Crea la tua password"}
      </Typhography>
      <Typhography className="pb-32" size="regular-16">
        Una password per accedere a i servizi di Leopart
      </Typhography>

      {statusCode === 0 && (
        <>
          <CustomTextInput
            label="Nome"
            placeholder="inserisci il nome"
            value={form.name}
            className="mb-4"
            onChange={handleEventInputChange2("name")}
          />
          <CustomTextInput
            label="Cognome"
            placeholder="inserisci il cognome"
            value={form.surname}
            className="mb-4"
            onChange={handleEventInputChange2("surname")}
          />
        </>
      )}
      <CustomPasswordInput
        label="Inserisci la tua nuova password"
        placeholder="password"
        className="mb-4"
        value={form.password}
        onChange={handleEventInputChange2("password")}
      />

      <CustomPasswordInput
        label="Conferma la password"
        placeholder="Ripeti la tua nuova password"
        className="pb-4"
        value={form.confirmPassword}
        onChange={handleEventInputChange2("confirmPassword")}
      />
      <div className="container__indicator__confirm__password">
        <Typhography className="label__indicator" type="span" size="bold-12">
          {securityPassword.label}
        </Typhography>
        <div className="indicator">
          <div
            className={`line line__${securityPassword.colorLine}`}
            style={{
              width: `${securityPassword.percentual}%`,
            }}
          />
        </div>
      </div>
      <ul>
        <li>
          <Typhography type="span" size="bold-12">
            Usa minimo 10 caratteri
          </Typhography>
        </li>
        <li>
          <Typhography type="span" size="bold-12">
            Includi almeno un numero
          </Typhography>
        </li>
        <li>
          <Typhography type="span" size="bold-12">
            Includi almeno un simbolo (!@#$%^*-_+=)
          </Typhography>
        </li>
      </ul>

      <CustomButton
        disabled={isConfirmButtonDisabled}
        fullWidth
        onClick={handleConfirmCoach}
      >
        Crea la tua password
      </CustomButton>
    </Fragment>
  );
};

export default RegistrationForm;
